import React, { useState, useEffect } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useHistory } from "react-router-dom";
import { PrePayment } from "./PrePayment";
import { RUSure } from "./RUSure";
import { sendGET, sendPOST, clientVersion, BaseURL } from "../utils/comm";
import {
  getValuesForHeadings,
  getColumnHeadings,
  checkAllSelected,
  isDemographicQuestion,
} from "./surveyUtils";

const FETCHING_QUESTIONS = 0,
  RUSURE = 1,
  QUESTIONS = 2,
  RECORDING = 3,
  PREPAYMENT = 4;

const sendAnswers = async (surveyResult) => {
  // Save to database etc...
  console.log("sendAnswers");
  //alert("sendAnswers");
  let { questions } = surveyResult;

  // Ensure all answers are present (force answer to 0 if not) AND numeric
  for (let idx = 0; idx < questions.length; idx++) {
    questions[idx].selection = parseInt(questions[idx].selection) || 0;
  }
  console.log("Saving to server, surveyResult:", surveyResult);
  /* Record the current date/time FROM the client so that the 'dateLocale' makes sense
     vs the server which is in another timezone. Server ADDs his date stamps too. */
  surveyResult.clientDateValue = new Date().getTime();
  surveyResult.clientDateISO = new Date().toISOString();
  surveyResult.clientDateLocale = new Date().toLocaleString();

  return sendPOST("/result", surveyResult);
};

const Recording = ({ surveyResult, setFinished }) => {
  console.log("Recording: surveyResult:", surveyResult);

  useEffect(() => {
    console.log("Recording: Calling sendAnswers...");
    const doSend = async () => {
      const newSurveyResult = await sendAnswers(surveyResult);
      console.log("Sent/recorded data, result:", surveyResult);
      setFinished("done", newSurveyResult);
    };
    doSend();
  }, []);

  return (
    //    <PageWrapper>
    <div
      style={{
        fontSize: "2em",
        fontWeight: "bolder",
        marginTop: "2em",
        textAlign: "center",
        //paddingTop: "100px",
      }}
    >
      <div style={{ marginBottom: "1em" }}>Recording data...</div>
      <CircularProgress size={80} thickness={6} />
    </div>
    //   </PageWrapper>
  );
};

const DisplayChoices = ({
  surveyResult,
  question,
  reevaluate,
  setNextQuestionRequired,
}) => {
  const [update, setUpdate] = useState(1);

  let headings = getColumnHeadings(question);
  let values = getValuesForHeadings(headings);

  if (question.DisplayAs === "typein") {
    return (
      <div style={{ paddingLeft: "1em" }}>
        <textarea
          autoFocus
          type="text"
          rows="4"
          cols="50"
          placeholder={question.question}
          value={surveyResult.demographics[question.AnswerList]}
          style={{ paddingLeft: "1em", float: "left" }}
          onChange={(e) => {
            surveyResult.demographics[question.AnswerList] =
              question.selection = e.target.value;
            reevaluate(true);
          }}
        />
      </div>
    );
  }

  if (headings.length > 6)
    return (
      <div style={{ paddingLeft: "1em" }}>
        <select
          style={{ paddingLeft: "1em", float: "left" }}
          value={question.selection}
          onChange={(e) => {
            if (e.target.value === "-1") {
              e.preventDefault();
              return;
            }
            //            question.selection = Number(e.target.value);
            question.selection = e.target.value;
            setUpdate((old) => old + 1);
            //alert("Set to:" + question.selection);
            // Let's now see if this question is one of the demographic-types and also
            // store the answer in a more digestable format in the top of the record.
            if (isDemographicQuestion(question)) {
              surveyResult.demographics[question.AnswerList] =
                question.selection;
              reevaluate(true);
            }
          }}
        >
          {headings.map((heading, idx) => {
            return (
              <option
                value={heading}
                key={heading}
                defaultValue={question.selection}
              >
                {heading}
              </option>
            );
          })}
        </select>
      </div>
    );

  return (
    <div style={{ paddingLeft: "1em" }}>
      {headings.map((heading, idx) => {
        return (
          <div key={idx}>
            <input
              type="radio"
              name={question.question}
              id={heading}
              value={values[idx]}
              checked={Number(values[idx]) === Number(question.selection)}
              onChange={(e) => {
                if (e.target.value === "-1") {
                  e.preventDefault();
                  return;
                }
                question.selection = e.target.value;
                if (heading.indexOf("Other") > -1) {
                  // This is SUCH a hack
                  setNextQuestionRequired(true);
                } else {
                  setNextQuestionRequired(false);
                }
                setUpdate((old) => old + 1);
                //alert("Set to:" + question.selection);
                // Let's now see if this question is one of the demographic-types and also
                // store the answer in a more digestable format in the top of the record.
                if (isDemographicQuestion(question)) {
                  surveyResult.demographics[question.AnswerList] = heading;
                  reevaluate(true);
                }
              }}
            />
            <label style={{ paddingLeft: "1em" }}>{heading}</label>
          </div>
        );
      })}
    </div>
  );
};

const ResponsiveQuestions = ({ surveyResult, setFinished }) => {
  const [filteredQuestions, setFilteredQuestions] = useState([]);
  const [reevaluate, setRevaluate] = useState(0);
  const [scroll, setScroll] = useState(0);
  const [error, setError] = useState("");

  // On smaller devices, the user will likely have 'scrolled down' a bit
  // on the prior screen.  And for some reason the browser likes to preserve
  // that scroll position, which means the top questions wont be seen.
  // So, we need to force the view to scroll-back to the top. We do this by
  // finding a blank div we put at the top of the question list and then
  // using the html 'scrollIntoView' feature.
  useEffect(() => {
    let element = document.getElementById("ScrollToTop");
    try {
      element.scrollIntoView();
    } catch (e) {
      console.error("Scroll not working...:", e);
    }
  }, [scroll]);

  useEffect(() => {
    let filtered;
    filtered = surveyResult.questions.filter((question, idx) => {
      if (question.isMetadata) return false;

      if (question.gender) {
        // Let's skip this question IF gender doesn't match
        if (
          surveyResult.demographics.gender === "Female" &&
          question.gender !== "f"
        ) {
          // alert("Skipping non-female question:" + question.question);
          return false;
        }
        if (
          surveyResult.demographics.gender === "Male" &&
          question.gender !== "m"
        )
          return false;
      }
      return true;
    });
    //alert("HACK/TESTING: Removing middle of questions array");
    //filtered.splice(7, 99);
    setFilteredQuestions(filtered);
  }, [reevaluate]);

  // We do this so that the NEXT windows are not scrolled-down to match this window
  if (scroll) {
    setFinished("done");
  }

  let nextButtonStyle = { backgroundColor: "grey" };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        overflow: "none",
      }}
    >
      <div id="ScrollToTop"></div>
      {filteredQuestions.map((q, idx) => {
        let style = {
          backgroundColor: idx % 2 ? "#e8e6e6" : "#edfcfc",
          padding: "1em",
        };
        return (
          <div key={idx} style={style}>
            <div style={{ fontWeight: "bold" }}>
              {idx + 1}.&nbsp;&nbsp; {q.question}
            </div>
            <DisplayChoices
              surveyResult={surveyResult}
              question={q}
              reevaluate={(e) => {
                setRevaluate((old) => old + 1);
              }}
              setNextQuestionRequired={(requiredOrNot) => {
                filteredQuestions[idx + 1].required = requiredOrNot;
              }}
            />
          </div>
        );
      })}
      <div style={{ color: "red", paddingLeft: "20px" }}>{error}</div>
      <div className="Submit">
        <a
          href="/"
          className="btnnext"
          style={{
            ...nextButtonStyle,
            marginLeft: "1em",
            backgroundColor:
              checkAllSelected(filteredQuestions) === -1 ? "green" : "grey",
          }}
          onClick={(e) => {
            e.preventDefault();
            setError("");
            let questionIdx = checkAllSelected(filteredQuestions);
            if (questionIdx > -1) {
              setError(
                "Your answer to one or more of our questions is missing. Our system " +
                  "requires an answer to every question in order to make more accurate " +
                  "predictions. Start by checking question number " +
                  (questionIdx + 1) +
                  ". Thank you."
              );
              return;
            }
            setScroll((old) => old + 1);
            //            setFinished("done");
          }}
        >
          Submit!
        </a>
      </div>
    </div>
  );
};

export default () => {
  const [surveyResult, setSurveyResult] = useState({
    questions: [],
    demographics: {},
    // Other survey/demographics info etc
  });
  const history = useHistory();
  const [phase, setPhase] = useState(FETCHING_QUESTIONS);
  const [showMessage, setShowMessage] = useState(null);
  const query = new URLSearchParams(window.location.search);

  useEffect(() => {
    const doFetch = async () => {
      console.log("Questionnaire: doFetch: Fetching survey (questions)...");

      if (query.get("dateValue")) {
        let temp = await sendGET(`/result/${query.get("dateValue")}`);
        if (!temp)
          alert(
            "Failed to retrieve data from server for " + query.get("dateValue")
          );
        else {
          setShowMessage(
            "Resuming your survey; Your data is filled-in; please review."
          );
          //alert("Resuming your survey; Your data is filled-in; please review.");
          setSurveyResult(temp);
        }
      } else {
        let questionsAPI = await sendGET("/questions/" + clientVersion);

        // Let's see if it is the old format which is just the questions arrray, OR
        // has the new 'version' attribute
        if (questionsAPI.serverVersion) {
          if (questionsAPI.serverVersion !== clientVersion) {
            console.log("Version missmatch, from server:", questionsAPI);
            setShowMessage(
              "Version missmatch: Client:" +
                clientVersion +
                " Server:" +
                questionsAPI.serverVersion +
                " BaseURL:" +
                BaseURL
            );
          }
        } else if (
          !window.confirm("Interacting with an old back end. Continue?")
        )
          return;

        surveyResult.clientVersion = clientVersion;

        // Force all questions to be required
        questionsAPI.questions.forEach((question) => {
          question.required = true;
        });

        // Let's set defaults for demographics
        setSurveyResult({
          ...surveyResult,
          questions: questionsAPI.questions,
          promos: questionsAPI.promos,
          userEmail:
            BaseURL.indexOf("localhost") !== -1
              ? "chris.stakutis@gmail.com-test"
              : "",
          promo: "",
        });
      }
      setPhase(RUSURE);
    };
    doFetch();
  }, []);

  let count = 0;

  switch (phase) {
    case FETCHING_QUESTIONS:
      return (
        <div
          style={{
            fontSize: "2em",
            fontWeight: "bolder",
            heightNo: "100%",
            marginTop: "2em",
            textAlign: "center",
          }}
        >
          <div style={{ marginBottom: "1em" }}>Loading survey...</div>
          <CircularProgress size={80} thickness={6} />
        </div>
      );
    case RUSURE:
      let showMessageTemp = showMessage;
      //setShowMessage(null);
      return (
        <RUSure
          setFinished={(status) => {
            if (status === "done") {
              setPhase(QUESTIONS);
              if (surveyResult.testMode) {
                surveyResult.questions.forEach((question) => {
                  // Force fake values if undefined
                  if (question.selection === undefined) {
                    let headings = getColumnHeadings(question);
                    let values = getValuesForHeadings(headings);
                    if (headings.length > 1) {
                      question.selection =
                        values[Math.floor(Math.random() * headings.length)];
                      if (isDemographicQuestion(question)) {
                        let result = question.selection;

                        /* Detect a <select> type and make sure it is isn't zero */
                        if (headings.length > 6) {
                          while (question.selection === 0)
                            question.selection =
                              values[
                                Math.floor(Math.random() * headings.length)
                              ];
                          result = question.selection;
                        }

                        if (typeof result === "number")
                          result = headings[values.indexOf(result)];
                        surveyResult.demographics[question.AnswerList] = result;
                      }
                    } else {
                      surveyResult.demographics[question.AnswerList] =
                        "Just some random text:" + count++;
                    }
                  }
                });
              }
            } else alert("Unexpected status value from RUSure:" + status);
          }}
          surveyResult={surveyResult}
          incomingMessage={showMessageTemp}
        />
      );
    case QUESTIONS:
      return (
        <ResponsiveQuestions
          surveyResult={surveyResult}
          setFinished={(status) => {
            switch (status) {
              case "done":
                setPhase(RECORDING);
                break;
              case "cancel":
                window.location.href = "https://www.complexhealthsolutions.com";
                break;
              case "exit":
              case "restart":
                setPhase(RUSURE);
                break;
              default:
                alert("Unexpected status value from RunQuestions:" + status);
            }
          }}
        />
      );
    case RECORDING:
      return (
        <Recording
          surveyResult={surveyResult}
          setFinished={(status, newSurveyResult) => {
            setSurveyResult(newSurveyResult);
            setPhase(PREPAYMENT);
          }}
        />
      );
    case PREPAYMENT:
      return (
        <PrePayment
          setFinished={(status) => {
            if (status === "done") {
              console.log(
                "Continuing to 'getpayment' component with dateValue:",
                surveyResult.dateValue
              );
              history.push("/getpayment/" + surveyResult.dateValue);
            } else setPhase(RUSURE);
          }}
          surveyResult={surveyResult}
        />
      );
    default:
      alert("Unknown phase:" + phase);
  }
};
